import { css } from '@mui/material/styles';
export const tabsComponentOverrides = {
    MuiTabs: {
        defaultProps: {
            scrollButtons: 'auto',
            selectionFollowsFocus: true
        },
        styleOverrides: {
            root: ({ theme }) => css `
                // [role="tablist"]
                min-height: 40px;
                box-shadow: inset 0 -1px ${theme.tokens.FuelColorBorderLight};
                position: relative;

                & .MuiTabs-indicator {
                    transition: none;
                }

                /* --- Contained --- */
                &[data-fuel-tabs-contained=true] {
                    & .MuiTab-root {
                        box-shadow: inset 0 -1px 0 0 ${theme.tokens.FuelColorBorderLight}, inset 1px 0 0 0 ${theme.tokens.FuelColorBorderLight}, inset 0 1px 0 0 ${theme.tokens.FuelColorBorderLight};
                        background-color: ${theme.tokens.FuelColorBackgroundWhite};

                        &.Mui-selected + .MuiTab-root {
                            box-shadow: inset 0px -1px 0 0px ${theme.tokens.FuelColorBorderLight}, inset 0px 1px 0 0px ${theme.tokens.FuelColorBorderLight};
                        }

                        &:last-of-type {
                            box-shadow: inset 0px -1px 0 0px ${theme.tokens.FuelColorBorderLight}, inset 1px 0px 0 0px ${theme.tokens.FuelColorBorderLight}, inset 0px 1px 0 0px ${theme.tokens.FuelColorBorderLight}, inset -1px 0px 0 0px ${theme.tokens.FuelColorBorderLight};
                        }

                        &.Mui-selected + .MuiTab-root:last-of-type {
                            box-shadow: inset 0px -1px 0 0px ${theme.tokens.FuelColorBorderLight}, inset 0px 1px 0 0px ${theme.tokens.FuelColorBorderLight}, inset -1px 0px 0 0px ${theme.tokens.FuelColorBorderLight};
                        }

                        &:after {
                            border-top-left-radius: 0;
                            border-top-right-radius: 0;
                            top: 0;
                            bottom: 0;
                        }

                        &:not(.Mui-selected):last-of-type:hover {
                            box-shadow: inset 0px -1px 0 0px ${theme.tokens.FuelColorBorderLight}, inset 0px 1px 0 0px ${theme.tokens.FuelColorBorderLight}, inset 1px 0px 0 0px ${theme.tokens.FuelColorBorderLight}, inset -1px 0px 0 0px ${theme.tokens.FuelColorBorderLight};
                        }

                        &:hover {
                            color: ${theme.tokens.FuelColorGray600};
                            background-color: ${theme.tokens.FuelColorGray50};
                            box-shadow: inset 0 -1px ${theme.tokens.FuelColorBorderLight};
                        }

                        &:active {
                            background-color: ${theme.tokens.FuelColorBackgroundActionDefaultPressed};
                            &:after {
                                height: 0px;
                                top: 0;
                            }

                        }

                        &:focus-visible {
                            box-shadow: inset 0 0 0 2px ${theme.tokens.FuelColorFocused};
                            border: none;
                        }
                    }


                    & .MuiTab-root.Mui-selected {
                        box-shadow: inset -1px 0px 0 0px ${theme.tokens.FuelColorBorderLight}, inset 1px 0px 0 0px ${theme.tokens.FuelColorBorderLight};
                        zIndex: 2;

                        &:after {
                            background-color: ${theme.tokens.FuelColorBackgroundActionDefaultSelectedBar};
                        }
                        &:focus-visible {
                            box-shadow: inset 0 0 0 2px ${theme.tokens.FuelColorFocused};
                            border: none;
                        }
                    }
                    & .MuiTabs-indicator {
                        height: 0;
                    }
                }

                & .MuiTabScrollButton-root {
                    background-color: #fffffff5;
                    position: absolute;
                    z-index: 50;
                    height: 100%;
                    transition-duration: 200ms;
                    opacity: 1;
                    border: solid 1px ${theme.tokens.FuelColorBorderLight};
                    border-bottom-color: ${theme.tokens.FuelColorBorderBase};

                    &.Mui-disabled {
                        opacity: 0;
                    }

                    &:first-of-type {
                        left: 0;
                        top: 0;
                    }

                    &:last-of-type {
                        right: 0;
                        top: 0;
                    }
                }
            `
        }
    },
    MuiTab: {
        styleOverrides: {
            root: ({ theme }) => css `
                /* --- Standard --- */
                // [role="tab"]
                color: ${theme.tokens.FuelColorGray600};
                font-size: ${theme.tokens.FuelFontSizeBase};
                opacity: 1;
                padding: 0 ${theme.tokens.FuelSpacing4};
                min-height: 40px;
                transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                align-items: center;
                position: relative;

                &.Mui-selected {
                    color: ${theme.tokens.FuelColorBrandPrimary};

                    &:after {
                        background-color: ${theme.tokens.FuelColorBackgroundActionDefaultSelectedBar};
                        content: '';
                        display: block;
                        height: 3px;
                        width: 100%;
                        position: absolute;
                        border-top-left-radius: 1px;
                        border-top-right-radius: 1px;
                        bottom: 0;
                    }
                }

                &:focus-visible {
                    box-shadow: inset 0 0 0 2px ${theme.tokens.FuelColorFocused};
                    border: none;
                }

                &:hover {
                    color: ${theme.tokens.FuelColorGray600};
                    background-color: ${theme.tokens.FuelColorGray50};
                    box-shadow: inset 0 -1px ${theme.tokens.FuelColorBorderLight};
                }

                &:active {
                    background-color: ${theme.tokens.FuelColorBackgroundActionDefaultPressed};
                    outline: solid 2px ${theme.tokens.FuelColorBorderSelected};
                    outline-offset: -2px;

                    &.Mui-selected:after {
                        height: 1px;
                    }
                }
            `
        }
    }
};
